import CloseButton from 'components/Button/CloseButton';
import CreateNewClassForm from 'containers/CreateNewClassForm';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getUser } from 'store/actions/user';

import styles from './AddClasses.module.scss';

const AddClass = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onClose = () => {
    dispatch(getUser());
    navigate(-1);
  };

  return (
    <div className={styles.addClassContainer}>
      <CloseButton variant="primary" onClick={onClose} className={styles.closeButton} />

      <CreateNewClassForm modal={false} welcomeStep={false} handleCancel={onClose} />
    </div>
  );
};

export default AddClass;
